<template>
  <div>
    <select v-model="selected" class="select-box" @change="onChanged">
      <option value="" style="display: none;"> {{text}} </option>
      <option v-for="(item, index) in itemList" :key="index">
        {{item}}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'select-box',
  props: {
    text: { type: String },
    itemList: { type: Array }
  },
  data () {
    return {
      selected: ''
    }
  },
  methods: {
    onChanged () {
      this.$emit('change-value', {
        'text': this.text,
        'ans': this.selected
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../unified.scss';
.select-box {
    width:100%;
    padding: $very-little-margin;
    margin: $very-little-margin $no-margin;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/SelectBox.vue